// extracted by mini-css-extract-plugin
export default {"fadeInUp":"animations_fadeInUp__RH1mh","zoomIn":"animations_zoomIn__NrzyQ","hidden":"animations_hidden__YrZBY"};